<script>
    import {SvelteToast} from '@zerodevx/svelte-toast';
</script>

<div class="toasts">
    <SvelteToast target="notifications" options={{duration: 3000, pausable: true, dismissable: true, reversed: true}} />
</div>

<style global>
    .toasts {
        --toastContainerZIndex: 2147483647;
        --toastContainerTop: auto;
        --toastContainerRight: 1rem;
        --toastContainerBottom: 4rem;
        --toastContainerLeft: auto;
        --toastBarHeight: 3px;
    }

    .toasts :global(._toastContainer .toast-success) {
        --toastBackground: var(--color-green);
        --toastBarBackground: var(--color-green-700);
    }

    .toasts :global(._toastContainer .toast-error) {
        --toastBackground: var(--color-red);
        --toastBarBackground: var(--color-red-700);
    }

    .toasts :global(._toastContainer ._toastMsg) {
        max-width: 100%;
        overflow-wrap: break-word;
    }
</style>
